var _defs, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgAdmNotification = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12.077,
    height: 15.524,
    viewBox: "0 0 12.077 15.524",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ff7e0f;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M10.453,18.024a1.6,1.6,0,0,0,1.592-1.592H8.861A1.592,1.592,0,0,0,10.453,18.024Zm4.777-4.777V9.267a4.85,4.85,0,0,0-3.582-5.031V3.694a1.194,1.194,0,0,0-2.388,0v.541A4.836,4.836,0,0,0,5.676,9.267v3.98L4.65,14.274a.8.8,0,0,0,.557,1.361H15.691a.8.8,0,0,0,.565-1.361Z",
    transform: "translate(-4.414 -2.5)"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAdmNotification, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/admNotification.c41ee29e.svg";
export { ForwardRef as ReactComponent };